import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 22 32",
  "content": "<symbol viewBox=\"0 0 22 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"trash\">\n    <path d=\"M1.846 26.769c0 1.692 1.385 3.077 3.077 3.077h12.308c1.692 0 3.077-1.385 3.077-3.077v-18.462h-18.462v18.462zM21.846 3.692h-5.385l-1.538-1.538h-7.692l-1.538 1.538h-5.385v3.077h21.538v-3.077z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol